export default "__VITE_ASSET__CskRjZ5Z__"